import { useState, useMemo } from 'react';
import {
    startOfWeek, endOfWeek, eachDayOfInterval, format,
    addWeeks, getWeek
} from 'date-fns';
import { vi } from 'date-fns/locale';

export const useWeekNavigation = (initialDate: Date) => {
    const [currentDate, setCurrentDate] = useState(initialDate);
    const [isCalendarVisible, setIsCalendarVisible] = useState(false);

    const weekDays = useMemo(() => {
        const start = startOfWeek(currentDate, { weekStartsOn: 1, locale: vi as any });
        const end = endOfWeek(currentDate, { weekStartsOn: 1, locale: vi as any });
        return eachDayOfInterval({ start, end });
    }, [currentDate]);

    const weekTitle = `Tuần ${getWeek(currentDate, { weekStartsOn: 1 })}/${format(currentDate, 'yyyy')}`;

    const navigateWeek = (weeks: number) => {
        setCurrentDate(prev => addWeeks(prev, weeks));
    };

    // HÀM CHỌN TUẦN/NGÀY
    const handleWeekSelect = (date: Date) => {
        setCurrentDate(date);
        setIsCalendarVisible(false);
    };
    
    // HÀM CHUYỂN THÁNG
    const handleMonthChange = (date: Date) => {
        setCurrentDate(date);
    };

    return {
        currentDate,
        weekDays,
        weekTitle,
        isCalendarVisible,
        setIsCalendarVisible,
        navigateWeek,
        handleWeekSelect,
        handleMonthChange,
    };
};